// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================= MARKET STRUCTURE WIDGET ================= */

.marketStructureCard {
  overflow: hidden;
}

.marketStructureHeader {
  align-items: flex-start;
  gap: 10px;
  padding-bottom: 10px;
}

.marketStructureHeader h2 {
  margin-bottom: 3px;
}

.marketStructureHeader p {
  margin: 0;
  font-size: 0.76rem;
  color: rgba(255, 255, 255, 0.48);
}

.marketStructureContent {
  display: flex;
  flex-direction: column;
  gap: 9px;
  padding: 12px 13px;
  border: 1px solid rgba(177, 136, 0, 0.16);
  border-radius: 16px;
  background:
    radial-gradient(circle at top left, rgba(177, 136, 0, 0.09), transparent 45%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.035), rgba(255, 255, 255, 0.015));
}

.marketStructureText {
  margin: 0;
  font-size: 0.82rem;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.78);
}

.marketStructureTakeaway {
  margin-top: 2px;
  padding: 10px 11px;
  border: 1px solid rgba(177, 136, 0, 0.22);
  border-radius: 13px;
  background: rgba(177, 136, 0, 0.07);
}

.marketStructureTakeaway span {
  display: block;
  margin-bottom: 5px;
  font-size: 0.62rem;
  font-weight: 900;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #f5d06f;
}

.marketStructureTakeaway p {
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.82);
}

.marketStructureState,
.marketStructureError,
.marketStructureEmpty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 96px;
  padding: 14px;
  border: 1px dashed rgba(177, 136, 0, 0.22);
  border-radius: 15px;
  background:
    radial-gradient(circle at center, rgba(177, 136, 0, 0.06), transparent 55%),
    rgba(255, 255, 255, 0.02);
  text-align: center;
}

.marketStructureState p,
.marketStructureError p,
.marketStructureEmpty p {
  margin: 5px 0 0;
  font-size: 0.78rem;
  line-height: 1.35;
  color: rgba(255, 255, 255, 0.5);
}

.marketStructureError strong,
.marketStructureEmpty strong {
  font-size: 0.82rem;
  color: rgba(255, 255, 255, 0.86);
}

.marketStructureError {
  border-color: rgba(255, 82, 82, 0.25);
  background: rgba(255, 82, 82, 0.04);
}

.marketStructureError strong {
  color: #ff9b9b;
}

.marketStructurePulse {
  width: 10px;
  height: 10px;
  margin: 0 auto 7px;
  border-radius: 999px;
  background: #b18800;
  box-shadow: 0 0 0 rgba(177, 136, 0, 0.45);
  animation: marketStructurePulse 1.5s infinite;
}

@keyframes marketStructurePulse {
  0% {
    box-shadow: 0 0 0 0 rgba(177, 136, 0, 0.45);
  }

  70% {
    box-shadow: 0 0 0 9px rgba(177, 136, 0, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(177, 136, 0, 0);
  }
}

@media (max-width: 900px) {
  .marketStructureContent {
    padding: 11px;
  }

  .marketStructureText {
    font-size: 0.8rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Styles/MarketStructureWidget.css"],"names":[],"mappings":"AAAA,gEAAgE;;AAEhE;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB;;mFAEiF;AACnF;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB;;6BAE2B;EAC3B,kBAAkB;AACpB;;AAEA;;;EAGE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* ================= MARKET STRUCTURE WIDGET ================= */\n\n.marketStructureCard {\n  overflow: hidden;\n}\n\n.marketStructureHeader {\n  align-items: flex-start;\n  gap: 10px;\n  padding-bottom: 10px;\n}\n\n.marketStructureHeader h2 {\n  margin-bottom: 3px;\n}\n\n.marketStructureHeader p {\n  margin: 0;\n  font-size: 0.76rem;\n  color: rgba(255, 255, 255, 0.48);\n}\n\n.marketStructureContent {\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n  padding: 12px 13px;\n  border: 1px solid rgba(177, 136, 0, 0.16);\n  border-radius: 16px;\n  background:\n    radial-gradient(circle at top left, rgba(177, 136, 0, 0.09), transparent 45%),\n    linear-gradient(180deg, rgba(255, 255, 255, 0.035), rgba(255, 255, 255, 0.015));\n}\n\n.marketStructureText {\n  margin: 0;\n  font-size: 0.82rem;\n  line-height: 1.45;\n  color: rgba(255, 255, 255, 0.78);\n}\n\n.marketStructureTakeaway {\n  margin-top: 2px;\n  padding: 10px 11px;\n  border: 1px solid rgba(177, 136, 0, 0.22);\n  border-radius: 13px;\n  background: rgba(177, 136, 0, 0.07);\n}\n\n.marketStructureTakeaway span {\n  display: block;\n  margin-bottom: 5px;\n  font-size: 0.62rem;\n  font-weight: 900;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #f5d06f;\n}\n\n.marketStructureTakeaway p {\n  margin: 0;\n  font-size: 0.8rem;\n  line-height: 1.4;\n  color: rgba(255, 255, 255, 0.82);\n}\n\n.marketStructureState,\n.marketStructureError,\n.marketStructureEmpty {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 96px;\n  padding: 14px;\n  border: 1px dashed rgba(177, 136, 0, 0.22);\n  border-radius: 15px;\n  background:\n    radial-gradient(circle at center, rgba(177, 136, 0, 0.06), transparent 55%),\n    rgba(255, 255, 255, 0.02);\n  text-align: center;\n}\n\n.marketStructureState p,\n.marketStructureError p,\n.marketStructureEmpty p {\n  margin: 5px 0 0;\n  font-size: 0.78rem;\n  line-height: 1.35;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.marketStructureError strong,\n.marketStructureEmpty strong {\n  font-size: 0.82rem;\n  color: rgba(255, 255, 255, 0.86);\n}\n\n.marketStructureError {\n  border-color: rgba(255, 82, 82, 0.25);\n  background: rgba(255, 82, 82, 0.04);\n}\n\n.marketStructureError strong {\n  color: #ff9b9b;\n}\n\n.marketStructurePulse {\n  width: 10px;\n  height: 10px;\n  margin: 0 auto 7px;\n  border-radius: 999px;\n  background: #b18800;\n  box-shadow: 0 0 0 rgba(177, 136, 0, 0.45);\n  animation: marketStructurePulse 1.5s infinite;\n}\n\n@keyframes marketStructurePulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(177, 136, 0, 0.45);\n  }\n\n  70% {\n    box-shadow: 0 0 0 9px rgba(177, 136, 0, 0);\n  }\n\n  100% {\n    box-shadow: 0 0 0 0 rgba(177, 136, 0, 0);\n  }\n}\n\n@media (max-width: 900px) {\n  .marketStructureContent {\n    padding: 11px;\n  }\n\n  .marketStructureText {\n    font-size: 0.8rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
